// extracted by mini-css-extract-plugin
export default {"container":"MobileBlock_container__7iXcw"};